import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Flex, H3, Modal, P } from "orcs-design-system";
import { useMutation } from "@apollo/client";
import { rotatePublicAPICredential } from "src/queries/mutations/apiKeys.graphql";

const RotateSecretModal = ({
  visible,
  clientId,
  onHideModal,
  onRotateSecret,
}) => {
  const [rotatePublicApiKey] = useMutation(rotatePublicAPICredential);
  const [rotateSecretError, setRotateSecretError] = useState(false);
  const handleRotateSecret = async () => {
    try {
      const result = await rotatePublicApiKey({
        variables: {
          clientId,
        },
      });
      if (result?.data?.result) {
        onRotateSecret(result.data.result);
      } else {
        throw new Error("Failed to rotate secret");
      }
    } catch (error) {
      setRotateSecretError(true);
    }
  };
  return (
    <Modal
      visible={visible}
      onClose={() => {
        setRotateSecretError(false);
        onHideModal();
      }}
      headerContent={<H3>Rotate Secret</H3>}
      footerContent={
        <Flex gap="s">
          {!rotateSecretError && (
            <Button
              variant="danger"
              onClick={() => {
                handleRotateSecret();
              }}
            >
              Rotate Secret
            </Button>
          )}
          <Button
            onClick={() => {
              setRotateSecretError(false);
              onHideModal();
            }}
          >
            Cancel
          </Button>
        </Flex>
      }
    >
      {!rotateSecretError && (
        <P mb="r" mt="r">
          Are you sure you want to rotate the secret? This action can not be
          undone. It will create a new secret and invalidate the old one.You
          will need to update your API key in your code.
        </P>
      )}
      {rotateSecretError && (
        <P mb="r" mt="r">
          An error has occurred while rotating the secret. Please try again.
        </P>
      )}
    </Modal>
  );
};

RotateSecretModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  clientId: PropTypes.string.isRequired,
  onHideModal: PropTypes.func.isRequired,
  onRotateSecret: PropTypes.func.isRequired,
};

export default RotateSecretModal;
